import { AnyIfEmpty } from 'react-redux';
import {
    GET_LOCATION_FAILURE,
    GET_LOCATION_REQUEST,
    GET_LOCATION_SUCCESS,
    GET_LOCATION_BY_ID_FAILURE,
    GET_LOCATION_BY_ID_REQUEST,
    GET_LOCATION_BY_ID_SUCCESS,
    CLEAR_PREVIOUS_LOCATION_DATA,
    GET_STATE_LOCATION_REQUEST,
    GET_STATE_LOCATION_SUCCESS,
    GET_STATE_LOCATION_FAILURE,
    GET_LOCATION_DETAILS_BY_ID_FAILURE,
    GET_LOCATION_DETAILS_BY_ID_REQUEST,
    GET_LOCATION_DETAILS_BY_ID_SUCCESS,
    GET_LOCATION_FILTERS_REQUEST,
    GET_LOCATION_FILTERS_SUCCESS,
    GET_LOCATION_FILTERS_FAILURE,
    RESET_LOCATION_FILTERS,
} from '../constants/location.constant';
import { error } from 'console';

const initialState = {
    loading: false,
    data: [],
    error: '',
    locationById: {
        loading: false,
        data: [],
        error: '',
    },
    stateLocations: {
        loading: false,
        data: [],
        error: '',
    },
    locationPublicDetails: {
        loading: false,
        data: [],
        error: ''
    },
    locationFilters: {
        loading: false,
        data: null,
        error: ''
    }
};

const locationReducer = (state = initialState, action: AnyIfEmpty<object>) => {
    switch (action.type) {
        case GET_LOCATION_REQUEST:
            return {
                ...state,
                loading: true,
            };

        case GET_LOCATION_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: '',
            };
        case GET_LOCATION_FAILURE:
            return {
                ...state,
                loading: false,
                data: [],
                error: action.payload,
            };
        case GET_LOCATION_BY_ID_REQUEST:
            return {
                ...state,
                locationById: {
                    ...state.locationById,
                    loading: true,
                    error: '',
                },
            };
        case CLEAR_PREVIOUS_LOCATION_DATA:
            return {
                ...state,
                locationById: {
                    ...state.locationById,
                    loading: false,
                    data: [],
                    error: '',
                },
            };
        case GET_LOCATION_BY_ID_SUCCESS:
            return {
                ...state,
                locationById: {
                    ...state.locationById,
                    loading: false,
                    data: action.payload,
                    error: '',
                },
            };
        case GET_LOCATION_BY_ID_FAILURE:
            return {
                ...state,
                locationById: {
                    ...state.locationById,
                    loading: false,
                    error: action.payload,
                },
            };

        case GET_STATE_LOCATION_REQUEST:
            return {
                ...state,
                stateLocations: {
                    data: [],
                    error: '',
                    loading: true,
                }
            };

        case GET_STATE_LOCATION_SUCCESS:
            return {
                ...state,
                stateLocations: {
                    data: action.payload,
                    error: '',
                    loading: false,
                }
            };
        case GET_STATE_LOCATION_FAILURE:
            return {
                ...state,
                stateLocations: {
                    data: [],
                    error: action.payload,
                    loading: false,
                }
            };

        case GET_LOCATION_DETAILS_BY_ID_REQUEST:
            return {
                ...state,
                locationPublicDetails: {
                    loading: true,
                    error: '',
                    data: []
                }
            }

        case GET_LOCATION_DETAILS_BY_ID_SUCCESS:
            return {
                ...state,
                locationPublicDetails: {
                    loading: false,
                    error: '',
                    data: action.payload
                }
            }

        case GET_LOCATION_DETAILS_BY_ID_FAILURE:
            return {
                ...state,
                locationPublicDetails: {
                    loading: false,
                    error: action.payload,
                    data: []
                }
            }

        case GET_LOCATION_FILTERS_REQUEST:
            return {
                ...state,
                locationFilters: {
                    ...state.locationFilters,
                    loading: true,
                    error: '',
                }
            }

        case GET_LOCATION_FILTERS_SUCCESS:
            return {
                ...state,
                locationFilters: {
                    ...state.locationFilters,
                    loading: false,
                    error: '',
                    data: action.payload
                }
            }

        case GET_LOCATION_FILTERS_FAILURE:
            return {
                ...state,
                locationFilters: {
                    ...state.locationFilters,
                    loading: false,
                    error: action.payload,
                    data: null
                }
            }

        case RESET_LOCATION_FILTERS:
            return {
                ...state,
                locationFilters: {
                    loading: false,
                    data: null,
                    error: ''
                }
            }

        default:
            return state;
    }
};

export default locationReducer;
